import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'executed-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExecutedProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentCreatedAt',
      'currentExecutionDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'boardTypeAndPlacement',
      'placer',
      'mostRecentAdjustmentPhoto',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'ExecutedProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/Uitgevoerd';
  }

  // Override
  protected filterOutIPBoardProjects(): boolean {
    return true;
  }

  public getPageTitle(): string {
    return 'Uitgevoerd';
  }

  // Override
  protected preProcessProjects(subProjects: SubProject[]): void {
    super.preProcessProjects(subProjects);

    subProjects.forEach((sp) => {
      if (
        sp.project != null &&
        CollectionHelper.isPopulated(sp.project.products)
      ) {
        sp.project.products.forEach((p) => this.preprocessProduct(p));
      }
    });
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }

  // Override
  public getDefaultSort(): string {
    return 'currentExecutionDate';
  }

  // Override
  public getDefaultSortDirection() {
    return 'desc';
  }
}
